import { combineReducers } from 'redux';

import country from './country';

export default combineReducers({
  country,
});
